<template>
  <!-- 网媒管理系统 异常情况处理 -->
  <div class="wm-error-tips-box border_box">
    <div class="errmsg-box border_box" v-if="errmsg === 20010 || errmsg === 20011">
      <img src="../../assets/images/fixedstatementerror/tips.png" alt=""/>
      <div class="tips-box border_box">
        <p>您的账号已停用</p>
        <p>请联系您的销售顾问<span>及时续约</span></p>
      </div>
    </div>
    <div class="errmsg-box border_box" v-else-if="errmsg === 20012">
      <img src="../../assets/images/fixedstatementerror/tips.png" alt=""/>
      <div class="tips-box border_box">
        <p>您的账号已弃用</p>
        <p>请联系您的销售顾问<span>及时续约</span></p>
      </div>
    </div>
    <div class="errmsg-box border_box" v-else-if="errmsg === 20013 || errmsg === 20017">
      <img src="../../assets/images/fixedstatementerror/tips.png" alt=""/>
      <div class="tips-box border_box">
        <p>请扫码绑定网媒账号对应的预警推送公众号后</p>
        <p>重新打开查看</p>
      </div>
    </div>
    <div class="errmsg-box border_box" v-else-if="errmsg === 20016">
      <img src="../../assets/images/fixedstatementerror/tips.png" alt=""/>
      <div class="tips-box border_box">
        <p>系统错误</p>
        <p>请联系您的销售顾问<span>及时反馈</span></p>
      </div>
    </div>
    <template v-else>
      <slot />
    </template>
  </div>
</template>
<script>
export default {
  name:'wmerrortips',
  props: {
    errmsg: {
      typeof: Number,
      default: 200
    }
  },
  data(){
    return {
    }
  },
  created(){
  },
  computed: {
   
  },
  mounted(){
    
  },
  methods:{
  }
}
</script>

<style scoped>
.wm-error-tips-box {
  height: 100vh;
  background: #fff;
}
.wm-error-tips-box .errmsg-box {
  padding-top: 440px;
  text-align: center;
}
.wm-error-tips-box .errmsg-box img {
  display: block;
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
}
.wm-error-tips-box .errmsg-box p {
  font-size: 28px;
  color: #444444;
  line-height: 42px;
}
.wm-error-tips-box .errmsg-box p span {
  color: #2c6af2;
}
</style>